import { useContext, useMemo, useState } from "react";
import { SearchContext } from "context/providers";

import Wrapper from "./molecules/Wrapper";
import SortableWrapper from "./molecules/SortableWrapper";
import { SKILL_TYPES } from "lookup";

export default function JobSearchAgent() {
  const { searchState, setSkillSearchState } = useContext(SearchContext);

  const { required, optional } = useMemo(() => {
    const required = searchState.skills?.required || [];
    const optional = searchState.skills?.optional || [];
    return { required, optional };
  }, [searchState.skills]);

  const [selectedSkill, setSelectedSkill] = useState(null);
  const [temporarySkills, setTemporarySkills] = useState(null);

  const getSkillTypeFor = (id) => {
    if (id === SKILL_TYPES.REQUIRED || required.some((s) => s.name === id)) {
      return SKILL_TYPES.REQUIRED;
    }
    if (id === SKILL_TYPES.OPTIONAL || optional.some((s) => s.name === id)) {
      return SKILL_TYPES.OPTIONAL;
    }
    return null;
  };

  const handleDragEnd = ({ over }) => {
    if (!over || !temporarySkills || !selectedSkill) return;

    const overId = over.id;
    const toType = getSkillTypeFor(overId);
    const toList = temporarySkills[toType];
    const toIndex = toList.findIndex((s) => s.name === overId);

    const insertAt =
      toIndex === -1 ||
      [SKILL_TYPES.REQUIRED, SKILL_TYPES.OPTIONAL].includes(overId)
        ? toList.length
        : toIndex;

    const updatedTo = [
      ...toList.slice(0, insertAt),
      selectedSkill,
      ...toList.slice(insertAt),
    ];

    const updatedSkills = {
      ...temporarySkills,
      [toType]: updatedTo,
    };

    setSkillSearchState(updatedSkills);
    setTemporarySkills(null);
    setSelectedSkill(null);
  };

  const handleDragStart = ({ active }) => {
    const activeId = active.id;
    const fromType = getSkillTypeFor(activeId);
    const fromList = searchState.skills[fromType];
    const skill = fromList.find((s) => s.name === activeId);

    const updatedFrom = fromList.filter((s) => s.name !== activeId);

    setSelectedSkill(skill);
    setTemporarySkills({
      ...searchState.skills,
      [fromType]: updatedFrom,
    });
  };

  const requiredSkills = temporarySkills?.required ?? required;
  const optionalSkills = temporarySkills?.optional ?? optional;

  return (
    <Wrapper
      handleDragEnd={handleDragEnd}
      handleDragStart={handleDragStart}
      handleDragCancel={() => {
        setSelectedSkill(null);
        setTemporarySkills(null);
      }}
      selectedSkill={selectedSkill}
    >
      <SortableWrapper
        skills={requiredSkills}
        altSkills={optionalSkills}
        skillType={SKILL_TYPES.REQUIRED}
      />
      <SortableWrapper
        skills={optionalSkills}
        altSkills={requiredSkills}
        skillType={SKILL_TYPES.OPTIONAL}
      />
    </Wrapper>
  );
}
